import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "label"]
  static values = { copiedText: String, failedText: String }

  copy(event) {
    event.preventDefault()

    const text = this.sourceTarget.textContent.trim()
    if (!text) return

    if (this.copyWithSelection(text)) {
      this.showResult(this.copiedTextValue)
      return
    }

    this.copyWithClipboardApi(text)
  }

  copyWithSelection(text) {
    const field = document.createElement("textarea")
    field.value = text
    field.setAttribute("readonly", "")
    field.style.position = "fixed"
    field.style.left = "-9999px"
    field.style.top = "0"
    document.body.appendChild(field)
    field.focus()
    field.select()
    field.setSelectionRange(0, field.value.length)

    let copied = false

    try {
      copied = document.execCommand("copy")
    } catch (_error) {
      copied = false
    } finally {
      field.remove()
    }

    return copied
  }

  async copyWithClipboardApi(text) {
    try {
      if (!navigator.clipboard?.writeText) throw new Error("Clipboard API unavailable")

      await navigator.clipboard.writeText(text)
      this.showResult(this.copiedTextValue)
    } catch (_error) {
      this.showResult(this.failedTextValue)
    }
  }

  showResult(text) {
    if (!this.hasLabelTarget) return

    const previousText = this.labelTarget.textContent
    this.labelTarget.textContent = text
    window.setTimeout(() => { this.labelTarget.textContent = previousText }, 1800)
  }
}
